// noinspection DuplicatedCode

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { roleGuard } from '@fapp/authentication';

// noinspection ES6PreferShortImport
import { PageNotFoundComponent } from '../standalone/page-not-found/page-not-found.component';
import { DashboardComponent } from './dashboard/dashboard.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'dashboard',
    component: DashboardComponent,
  },
  {
    path: 'printerstatus',
    loadChildren: () =>
      import('../../shared/printer-alerts/printer-alerts.module').then(
        m => m.PrinterAlertsModule
      ),
  },
  {
    path: 'users',
    loadChildren: () =>
      import('../../shared/users/users.module').then(m => m.UsersModule),
    canMatch: [roleGuard('Admins')],
  },
  {
    path: 'companies',
    loadChildren: () =>
      import('../../shared/companies/companies.module').then(
        m => m.CompaniesModule
      ),
    canMatch: [roleGuard('Admins')],
  },
  {
    path: 'customers',
    loadChildren: () =>
      import('../../shared/customers/customers.module').then(
        m => m.CustomersModule
      ),
  },
  {
    path: 'orders',
    loadChildren: () =>
      import('../../shared/orders/orders.module').then(m => m.OrdersModule),
  },
  {
    path: 'sds-printers',
    loadChildren: () =>
      import('../../shared/sds-printers/sds-printers.module').then(
        m => m.SDSPrintersModule
      ),
  },
  {
    path: 'sds-customers',
    loadChildren: () =>
      import('../../shared/sds-customers/sds-customers.module').then(
        m => m.SDSCustomersModule
      ),
  },
  {
    path: 'sds-consumable-requests',
    loadChildren: () =>
      import(
        '../../shared/sds-consumable-requests/sds-consumable-requests.module'
      ).then(m => m.SDSConsumableRequestsModule),
  },
  {
    path: 'printer-order-requests',
    loadChildren: () =>
      import(
        '../../shared/printer-order-requests/printer-order-requests.module'
      ).then(m => m.PrinterOrderRequestsModule),
  },
  {
    path: 'order-management',
    loadChildren: () =>
      import('../../shared/order-management/order-management.module').then(
        m => m.OrderManagementModule
      ),
  },
  {
    path: 'printer-cost-analysis',
    loadChildren: () =>
      import(
        '../../shared/printer-cost-analysis/printer-cost-analysis.module'
      ).then(m => m.PrinterCostAnalysisModule),
  },
  {
    path: 'ppudata',
    loadChildren: () =>
      import('../../shared/invoicing/invoicing.module').then(
        m => m.InvoicingModule
      ),
  },
  {
    path: 'ppumaster',
    loadChildren: () =>
      import('../../shared/customer-invoices/customer-invoices.module').then(
        m => m.CustomerInvoicesModule
      ),
  },
  {
    path: 'new-month-generator',
    loadChildren: () =>
      import(
        '../../shared/new-month-generator/new-month-generator.module'
      ).then(m => m.NewMonthGeneratorModule),
  },
  {
    path: 'ppu-invoicing',
    loadChildren: () =>
      import('../../shared/ppu-invoicing/ppu-invoicing.module').then(
        m => m.PPUInvoicingModule
      ),
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class StaffRoutingModule {}
